import { useEffect, useState } from "react";
import { REACT_APP_API_BASE_URL } from "../../apiurl";

export default function SmartAPISignup() {
  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [signupIp, setSignupIp] = useState("");
  const [signupDeviceId, setSignupDeviceId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setSignupIp(data.ip))
      .catch(() => setSignupIp("Unknown"));

    try {
      if (window && window.process && window.process.type) {
        // Safe check for electron
        setSignupDeviceId("ELECTRON-DEVICE");
      } else {
        const prefix = /Windows/i.test(navigator.userAgent)
          ? "DESKTOP"
          : /Mac/i.test(navigator.userAgent)
            ? "MACBOOK"
            : /Android/i.test(navigator.userAgent)
              ? "ANDROID"
              : "DEVICE";
        const randomId = Math.random().toString(36).substring(2, 8).toUpperCase();
        setSignupDeviceId(`${prefix}-${randomId}`);
      }
    } catch {
      setSignupDeviceId("UNKNOWN-DEVICE");
    }
  }, []);

  const handleSendOtp = (e) => {
    e.preventDefault();
    if (!/^\d{10}$/.test(phoneNumber)) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }
    setStep(2);
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    if (otp !== "111111") {
      alert("Invalid OTP. Please enter correct OTP.");
      return;
    }
    setStep(3);
  };

  const handleCompleteSignup = async (e) => {
    e.preventDefault();
    if (!name.trim()) return alert("Please enter your full name.");
    if (!/^\S+@\S+\.\S+$/.test(email)) return alert("Please enter a valid email address.");

    setIsLoading(true);
    setStatus("Creating your account...");

    try {
      const res = await fetch(`${REACT_APP_API_BASE_URL}api/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          phone: phoneNumber,
          name,
          email,
          signupip: signupIp,
          signupdeviceid: signupDeviceId,
        }),
      });
      const data = await res.json();
      setIsLoading(false);

      if (!res.ok) throw new Error(data.message || "Signup failed");

      // localStorage.setItem("user_phone", phoneNumber);
      // localStorage.setItem("user_name", name);
      // localStorage.setItem("user_email", email);

      setStatus("✅ Signup successful! Redirecting...");
      setTimeout(() => (window.location.href = "/"), 1500);
    } catch (err) {
      setStatus("❌ " + err.message);
      setIsLoading(false);
    }
  };

  const goBack = () => setStep(step - 1);

  const inputStyle = {
    width: "100%",
    padding: "14px 18px",
    fontSize: "16px",
    borderRadius: "12px",
    border: "1px solid var(--border-medium)",
    marginBottom: "20px",
    boxSizing: "border-box",
  };

  const buttonStyle = (variant = "primary") => ({
    width: "100%",
    padding: "14px",
    fontSize: "16px",
    fontWeight: "600",
    borderRadius: "12px",
    border: "none",
    cursor: "pointer",
    marginBottom: "16px",
    ...(variant === "primary"
      ? { background: "linear-gradient(120deg,#6366f1,#8b5cf6)", color: "#fff" }
      : { background: "#fff", color: "#6366f1", border: "1px solid #c7d2fe" }),
  });

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(120deg,#f6f9ff,#eef2ff)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        fontFamily: "Inter, sans-serif",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: 20,
          boxShadow: "0 12px 40px rgba(93,93,109,0.12)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: "linear-gradient(120deg,#0f172a,#1e293b)",
            padding: "32px 24px",
            textAlign: "center",
          }}
        >
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 700, color: "#fff" }}>
            Create Account
          </h1>
          <p style={{ margin: "8px 0 0", fontSize: 14, color: "rgba(255,255,255,0.8)" }}>
            Step {step} of 3
          </p>
        </div>

        <div style={{ padding: 32 }}>
          {step === 1 && (
            <form onSubmit={handleSendOtp}>
              <p style={{ textAlign: "center", color: "#475569", marginBottom: 24 }}>
                Enter your mobile number to get started
              </p>
              <input
                type="tel"
                placeholder="10-digit mobile number"
                value={phoneNumber}
                onChange={(e) =>
                  setPhoneNumber(e.target.value.replace(/\D/g, "").slice(0, 10))
                }
                style={{
                  ...inputStyle,
                  textAlign: "center",
                  fontSize: 18,
                  letterSpacing: 2,
                }}
              />
              <button type="submit" style={buttonStyle()}>
                Send OTP
              </button>
            </form>
          )}

          {step === 2 && (
            <form onSubmit={handleVerifyOtp}>
              <p style={{ textAlign: "center", color: "#475569", marginBottom: 20 }}>
                Enter the 6-digit OTP sent to whatsapp <strong>{phoneNumber}</strong>
              </p>  
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                style={{
                  ...inputStyle,
                  textAlign: "center",
                  fontSize: 18,
                  letterSpacing: 3,
                }}
              />
              <button type="submit" style={buttonStyle()}>
                Verify OTP
              </button>
              <button type="button" onClick={goBack} style={buttonStyle("secondary")}>
                ← Back
              </button>
            </form>
          )}

          {step === 3 && (
            <form onSubmit={handleCompleteSignup}>
              <p style={{ textAlign: "center", color: "#475569", marginBottom: 24 }}>
                Almost there! Tell us about yourself
              </p>
              <input
                type="text"
                placeholder="Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={inputStyle}
              />
              <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={inputStyle}
              />
              <button type="submit" style={buttonStyle()} disabled={isLoading}>
                {isLoading ? "Creating Account..." : "Complete Signup"}
              </button>
              <button type="button" onClick={goBack} style={buttonStyle("secondary")}>
                ← Back
              </button>

              <div style={{ marginTop: 10, fontSize: 12, color: "#64748b" }}>
                <strong>IP:</strong> {signupIp || "Fetching..."} <br />
                <strong>Device:</strong> {signupDeviceId || "Detecting..."}
              </div>
            </form>
          )}

          {status && (
            <p
              style={{
                textAlign: "center",
                color: status.startsWith("❌") ? "#dc2626" : "var(--color-primary)",
                fontSize: 14,
                fontWeight: 500,
                marginTop: 10,
              }}
            >
              {status}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}